import { useEffect } from "react";
import { useNavigate, Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { useAuth } from "@/AuthContext";
import { LangSwitcher } from "@/components/LangSwitcher";
import { SeoHead } from "@/components/SeoHead";

export default function Login() {
  const { user, loading, login } = useAuth();
  const { t } = useTranslation();
  const navigate = useNavigate();

  useEffect(() => {
    if (!loading && user) navigate("/dashboard");
  }, [user, loading, navigate]);

  return (
    <div className="min-h-screen bg-[#FAFAFA] flex flex-col">
      <SeoHead pageKey="login" noindex />
      <header className="max-w-6xl mx-auto w-full px-6 py-6 flex items-center justify-between">
        <Link to="/" className="font-heading font-extrabold text-xl tracking-tight" data-testid="login-logo-link">
          depoia<span className="text-[#FF4F00]">.</span>
        </Link>
        <LangSwitcher />
      </header>
      <div className="flex-1 flex items-center justify-center px-6">
        <div className="w-full max-w-sm bg-white border border-zinc-200 rounded-lg p-10">
          <h1 className="font-heading font-extrabold text-2xl tracking-tight mb-2">{t("login.title")}</h1>
          <p className="text-sm text-zinc-500 mb-8">{t("login.sub")}</p>
          <button
            data-testid="google-login-btn"
            onClick={login}
            className="w-full py-3.5 bg-[#0A0A0A] text-white rounded-full font-semibold flex items-center justify-center gap-3 hover:bg-zinc-800 transition-colors"
          >
            <svg width="18" height="18" viewBox="0 0 24 24"><path fill="#fff" d="M22.56 12.25c0-.78-.07-1.53-.2-2.25H12v4.26h5.92a5.06 5.06 0 0 1-2.2 3.32v2.77h3.57c2.08-1.92 3.27-4.74 3.27-8.1z"/><path fill="#fff" d="M12 23c2.97 0 5.46-.98 7.28-2.66l-3.57-2.77c-.98.66-2.23 1.06-3.71 1.06-2.86 0-5.29-1.93-6.16-4.53H2.18v2.84C3.99 20.53 7.7 23 12 23z"/><path fill="#fff" d="M5.84 14.09c-.22-.66-.35-1.36-.35-2.09s.13-1.43.35-2.09V7.07H2.18A10.96 10.96 0 0 0 1 12c0 1.77.42 3.45 1.18 4.93l2.85-2.22.81-.62z"/><path fill="#fff" d="M12 5.38c1.62 0 3.06.56 4.21 1.64l3.15-3.15C17.45 2.09 14.97 1 12 1 7.7 1 3.99 3.47 2.18 7.07l3.66 2.84c.87-2.6 3.3-4.53 6.16-4.53z"/></svg>
            {t("login.btn")}
          </button>
          <p className="text-xs text-zinc-400 mt-6 text-center">{t("login.small")}</p>
        </div>
      </div>
    </div>
  );
}
